import { MembershipSubscriptionUser } from '@frontend/unhideschool/modules/membership/models/membership-subscription-user.model';
import { asNumber } from '@frontend/unhideschool/app/helpers/utility-functions';

export interface UserSearchFoundUserModel {
    avatarUrl: string;
    btnLabel: string;
    email: string;
    fullname: string;
    uid: number;
    invited: boolean;
    memberAlready: boolean;
}

export class UserSearchFoundUser implements UserSearchFoundUserModel {
    avatarUrl: string;
    btnLabel: string;
    email: string;
    fullname: string;
    uid: number;
    memberAlready: boolean;
    invited: boolean;

    constructor(user: MembershipSubscriptionUser, isSubscriptionMember: boolean) {
        this.memberAlready = isSubscriptionMember;
        this.btnLabel = this.memberAlready ? 'Já adicionado' : this.invited ? 'Convite Enviado' : 'Enviar convite';
        this.avatarUrl = user.profilepicture;
        this.email = user.email;
        this.fullname = user.fullname;
        this.uid = asNumber(user.uid);
    }
}
